import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, filter, map } from 'rxjs/operators';
import { Action } from 'redux';
import { CreateCollaborator } from '../action-creators';
import AppState from '../../state';
import { CreateArtistInviteSuccess } from '../../artist/action-creators';
import { CREATE_ARTIST_INVITE_SUCCESS } from '../../artist/actions';
import { NoOp } from '../../ui/action-creators';

/**
 *
 * This effect creates collaborators after a successful Artist Invite
 *
 */

export const createCollaboratorsAfterInvite = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, CreateArtistInviteSuccess>(CREATE_ARTIST_INVITE_SUCCESS),
    filter(
      (action) => action.source?.type === 'COLLABORATOR' && !!action.source.id
    ),
    withLatestFrom(state$),
    filter(([_, state]) => !!state.release.release?.id),
    map(([action, state]) => {
      if (!action.source?.id) {
        return new NoOp();
      }

      return new CreateCollaborator({
        assetId: action.source.id,
        assetType: action.source.assetType,

        type: action.source.type,

        name: action.artist.name,
        contact: action.artist.email || action.artist.telephone || '',
        contactType: action.artist.telephone ? 'sms' : 'email',

        collaboratorType: 'ARTIST',
        collaboratorId: action.artist.id,

        role: action.role,

        releaseId: state.release.release?.id,
      });
    })
  );
